// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";
import SecurityNotice from "../security-notice";

type OwnProps = $Exact<{
  ...PropsFromLocalize,
  notices?: string[],
  onExport: () => void,
  onClose: () => void,
}>;

const ExportSecurityNoticeModal = (props: OwnProps) => {
  const defaultNotices = [
    "REPORT_CONFIDENTIAL_INFORMANTIOM",
    "REPORT_SECURITY_INFORMANTIOM",
    "REPORT_SHARE_WARNING",
  ];

  const handleExport = () => {
    props.onExport();
    props.onClose();
  };

  const getNotices = () => {
    return props.notices ? props.notices : defaultNotices;
  };

  return (
    <Modal className="modal-normal">
      <ModalHeader toggle={props.onClose} className="d-flex justify-content-between">
        {props.t("EXPORT")}
      </ModalHeader>
      <ModalBody>
        <SecurityNotice notices={getNotices()} />
      </ModalBody>
      <ModalFooter className="d-flex justify-content-end">
        <Button color="secondary" onClick={props.onClose}>
          {props.t("CANCEL")}
        </Button>
        <Button materialIcon="download" onClick={handleExport}>
          {props.t("EXPORT")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default localize()(ExportSecurityNoticeModal);
